import { actionCopyEs } from "./actionCopy";

export const ratingsListCopyEs = {
    addActivityPlaceholder: (current: number, max: number) => `Añadir la actividad ${current}/${max}`,
    add: actionCopyEs.add,
    emptyHint: "Añada actividades aquí arriba para empezar a valorar su dificultad",
    noDifficulty: "Ninguna dificultad",
    unableToDo: "Imposible de realizar",
    loading: "Cargando las actividades...",
    loadError: "No se ha podido cargar su lista de actividades. Inténtelo de nuevo.",
    noBaselineActivities:
        "No se ha encontrado ninguna actividad de referencia para esta monitorización. Complete el primer registro antes de enviar un seguimiento.",
    followUpHint: "Valore su dificultad actual para cada actividad elegida durante el registro inicial.",
};
